import axios from 'axios'
import commonUrl from '../common/js/commonUrl.js'
import {loadUserId, loadVillageId} from '../common/js/cache.js'
// import { loadVillageId, loadUserId } from '../common/js/cache.js'
import qs from 'qs'

// 判断是否为工作人员
export function isWorker() {
  const data = {
    user_id: loadUserId()
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/Worker`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 去申请为工作人员
export function applyWorker() {
  const data = {
    user_id: loadUserId(),
    areas_id: loadVillageId()
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/apply`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 显示投票列表
export function getVoteList() {
  const data = {
    user_id: loadUserId()
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/getVote`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 选择 苑 幢 单元
export function getAreas(id, vid, yid, did, stype) {
  const data = {
    areas_id: id,
    vote_id: vid,
    yuan_id: yid,
    dong_id: did,
    scope_type: stype
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/voteHousr`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 选择单元后去显示网络投票结果
export function getVote(did, vid, newold) {
  const data = {
    danyuan_id: did,
    vote_id: vid,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/voteRoomNum`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 选择单元后显示满意度投票结果
export function getSatVote(did, vid, newold) {
  const data = {
    danyuan_id: did,
    sat_id: vid,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php//home/Votestatistics/satRoomNum`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 确认提交网络投票结果
export function submitVote(aid, vid, datas, newold) {
  const data = {
    areas_id: aid,
    vote_id: vid,
    data: datas,
    user_id: loadUserId(),
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/setVoteRoom`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 确认提交满意度投票结果
export function submitSatVote(aid, vid, datas, newold) {
  const data = {
    areas_id: aid,
    sat_id: vid,
    data: datas,
    user_id: loadUserId(),
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/setSatRoom`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 查看小区单元网络投票结果
export function lookVote(did, vid, newold) {
  const data = {
    danyuan_id: did,
    vote_id: vid,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/alreadyVote`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 查看小区单元满意度投票结果
export function lookSatVote(did, vid, newold) {
  const data = {
    danyuan_id: did,
    sat_id: vid,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/alreadySat`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 取消网络投票
export function deleteVote(id, newold) {
  const data = {
    id: id,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/cancelVote`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 取消满意度调查投票
export function deleteSatVote(id, newold) {
  const data = {
    id: id,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/cancelSat`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 点击网络投票小区列表已投票查看全部投票
export function lookAlreadyVote(aid, id) {
  const data = {
    areas_id: aid,
    vote_id: id
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/getAllVote`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 网络投票列表页面（已投票详情）
export function alreadyVoteDetail (aid, id, newold) {
  const data = {
    areas_id: aid,
    vote_id: id,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/getVoteStatisticsDetails`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}
export function alreadyStaDetail (aid, id, newold) {
  const data = {
    areas_id: aid,
    vote_id: id,
    type: newold,
    user_id: loadUserId()
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/getStatisticsDetails`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}
// 点击满意度调查投票小区列表已投票查看全部投票
export function lookAlreadySat(aid, id, newold) {
  const data = {
    areas_id: aid,
    sat_id: id,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php//home/Votestatistics/getAllSat`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 点击网络投票小区列表已送票查看全部送票
export function lookSendVote(id, newold) {
  const data = {
    vote_id: id,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/getGiveVote`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 点击满意度调查小区列表已送票查看全部送票
export function lookSendSat(id, newold) {
  const data = {
    sat_id: id,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/getGiveSat`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 点击网络投票统计小区列表已回收情况
export function lookRecycleVote(id, newold) {
  const data = {
    vote_id: id,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/getRecoveryVote`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 点击满意度调查投票统计小区列表已回收情况
export function lookRecycleSat(id, newold) {
  const data = {
    sat_id: id,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/getRecoverySat`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 拜访记录基本信息查看
export function getVisitRecord (hid, id, newold) {
  const data = {
    house_id: hid,
    vote_id: id,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/getVisitRecord`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}

// 拜访记录提交
export function postRecord (hid, id, remark, img, newold) {
  const data = {
    house_id: hid,
    vote_id: id,
    remark: remark,
    serverIds: img,
    type: newold
  }
  return axios({
    method: 'POST',
    url: `${commonUrl.apihost}index.php/home/Votestatistics/saveRecord`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((err) => {
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/api/toupiaotongji.js